import { render, staticRenderFns } from "./FansFollow.vue?vue&type=template&id=baf02c2a&scoped=true"
import script from "./FansFollow.vue?vue&type=script&lang=js"
export * from "./FansFollow.vue?vue&type=script&lang=js"
import style0 from "./FansFollow.vue?vue&type=style&index=0&id=baf02c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf02c2a",
  null
  
)

export default component.exports